import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  toggle() {
    this.element.classList.toggle("float-small");
    this.element.classList.toggle("float-normal");
  }
}
